import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Fleet from "@/pages/Fleet";
import CarDetail from "@/pages/CarDetail";
import Cenik from "@/pages/Cenik";
import Podminky from "@/pages/Podminky";
import ONas from "@/pages/ONas";
import Kontakt from "@/pages/Kontakt";
import Rezervace from "@/pages/Rezervace";
import RezervaceHotovo from "@/pages/RezervaceHotovo";
import Cookies from "@/pages/Cookies";
import Gdpr from "@/pages/Gdpr";
import ObchodniPodminky from "@/pages/ObchodniPodminky";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/vozovy-park" element={withLayout(<Fleet />)} />
          <Route path="/vuz/:id" element={withLayout(<CarDetail />)} />
          <Route path="/cenik" element={withLayout(<Cenik />)} />
          <Route path="/podminky" element={withLayout(<Podminky />)} />
          <Route path="/o-nas" element={withLayout(<ONas />)} />
          <Route path="/kontakt" element={withLayout(<Kontakt />)} />
          <Route path="/rezervace" element={withLayout(<Rezervace />)} />
          <Route path="/rezervace/hotovo" element={withLayout(<RezervaceHotovo />)} />
          <Route path="/cookies" element={withLayout(<Cookies />)} />
          <Route path="/gdpr" element={withLayout(<Gdpr />)} />
          <Route path="/obchodni-podminky" element={withLayout(<ObchodniPodminky />)} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
